import { render } from "./ProgramItemComponent.vue?vue&type=template&id=289a3602"
import script from "./ProgramItemComponent.vue?vue&type=script&lang=js"
export * from "./ProgramItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__